angular
    .module('app')
    .component('badgesEdit', {
        templateUrl: '/templates/pages/badges/badgesEdit/badgesEdit.html',
        controller: 'BadgeEditController',
        controllerAs: 'vm',
    });